import api from "./axios";
import {
  FavorableDateSelectionRequest,
  FavorableDayReport,
  FavorableMonthReport,
} from "@/types/calculators";

export async function fetchMonthDates(
  request: FavorableDateSelectionRequest
): Promise<FavorableMonthReport> {
  const res = await api.get(`/favourable-dates/month-report`, {
    params: request,
  });

  return res.data;
}

export async function fetchDayReport(
  request: FavorableDateSelectionRequest,
  date: string
): Promise<FavorableDayReport> {
  const res = await api.get(`/favourable-dates/day-report`, {
    params: {
      ...request,
      requested_date: date,
    },
  });

  return res.data;
}
